import { setLocation } from 'bv-helpers/location';
import { MINUTE_IN_MILLIS } from 'bv-helpers/datetime';
import postLocationData from '../api/post_location_data';

const revokeReason = {
  MISSING_GEOLOCATION: 'MISSING_GEOLOCATION',
};

const logOutIfNeeded = (logoutNeed = false, reason = null) => {
  if (logoutNeed) {
    setLocation(`/logout${reason ? `?reason=${reason}` : ''}`);
  }
};

export const getPosition = async (logOutOnReject = true) => {
  const buildPosition = (position) => ({
    latitude: position.coords.latitude,
    longitude: position.coords.longitude,
  });

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => resolve(buildPosition(position)),
      () => reject(logOutIfNeeded(logOutOnReject, revokeReason.MISSING_GEOLOCATION)),
    );
  });
};

const positionPost = async () => {
  const res = await postLocationData();
  if (res?.geopositionNeed) {
    const position = await getPosition(true);
    const response = await postLocationData({ position });
    logOutIfNeeded(response?.logout);
  }
  logOutIfNeeded(res?.logout);
};

export const locationCheckTimer = () => {
  positionPost();
  setInterval(positionPost, 5 * MINUTE_IN_MILLIS);
};
